(()=>{
 const init=()=>{
  let lightbox=document.getElementById('reset-lightbox');
  if(!lightbox){
   lightbox=document.createElement('dialog');
   lightbox.id='reset-lightbox';
   lightbox.className='reset-lightbox';
   lightbox.setAttribute('aria-label','Enlarged product image');
   lightbox.innerHTML='<button type="button" class="reset-close" data-lightbox-close aria-label="Close enlarged image" autofocus><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button><figure><img alt=""><figcaption aria-live="polite"></figcaption></figure><nav aria-label="Image navigation"><button type="button" data-image-prev aria-label="Previous image">Previous</button><span data-image-count></span><button type="button" data-image-next aria-label="Next image">Next</button></nav>';
   const bloom=document.querySelector('.kimo-bloom-icon'); if(bloom) lightbox.querySelectorAll('[data-image-prev],[data-image-next]').forEach(button=>button.append(bloom.cloneNode(true)));
   document.body.append(lightbox);
   const show=index=>{
    const images=lightbox.images;
    lightbox.imageIndex=(index+images.length)%images.length;
    const source=images[lightbox.imageIndex],target=lightbox.querySelector('img');
    const enlargedURL=new URL(source.currentSrc||source.src,location.href);enlargedURL.searchParams.set('width','2000');if(!target.getAttribute('src'))target.src=source.currentSrc||source.src;
    window.kimoLoadImage(target,enlargedURL.href,source.alt);
    lightbox.querySelector('figcaption').textContent=source.alt.replace(/\s*[—–-]\s*lifestyle view\s*[12]\s*$/i, '');
    lightbox.querySelector('[data-image-count]').textContent=`${lightbox.imageIndex+1} / ${images.length}`;
   };
   lightbox.showImage=show;
   lightbox.querySelector('[data-lightbox-close]').addEventListener('click',()=>lightbox.close());
   lightbox.querySelector('[data-image-prev]').addEventListener('click',()=>show(lightbox.imageIndex-1));
   lightbox.querySelector('[data-image-next]').addEventListener('click',()=>show(lightbox.imageIndex+1));
   lightbox.addEventListener('keydown',event=>{
    if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
     event.preventDefault();show(lightbox.imageIndex+(event.key==='ArrowLeft'?-1:1));
    }
   });
   lightbox.addEventListener('close',()=>lightbox.returnFocus?.focus());
   lightbox.addEventListener('click',event=>{if(event.target===lightbox)lightbox.close();});
  }
  document.querySelectorAll('[data-reset-enlarge]').forEach(button=>{
   if(button.dataset.bound)return;
   button.dataset.bound='true';
   button.addEventListener('click',()=>{
    lightbox.images=Array.from(button.closest('.reset-dialog-images').querySelectorAll('img')).filter(image=>!image.closest('figure')?.hidden);
    lightbox.returnFocus=button;
    lightbox.showImage(lightbox.images.indexOf(button.querySelector('img')));
    lightbox.showModal();
   });
  });
  document.querySelectorAll('[data-reset-variant]').forEach(select=>{
   if(select.dataset.bound)return;
   select.dataset.bound='true';
   const form=select.closest('form'),button=form.querySelector('[data-reset-add]'),buyNow=form.querySelector('[data-reset-buy-now]');
   const selectors=Array.from(form.querySelectorAll('[data-reset-option]'));
   const update=()=>{
    const option=select.selectedOptions[0];
    if(!option){button.disabled=true;button.textContent=button.dataset.unavailableLabel;if(buyNow)buyNow.hidden=true;return;}
    form.querySelector('[data-reset-price]').textContent=option.dataset.price;
    button.disabled=option.dataset.available!=='true';
    if(buyNow)buyNow.hidden=button.disabled;
    button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;
    const values=JSON.parse(option.dataset.options||'[]');
    selectors.forEach((input,index)=>{input.value=values[index];});
    window.kimoUpdateColorGallery?.(form,values);
    if(location.pathname===('/products/'+select.dataset.productHandle)){
     const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url);
    }
   };
   select.addEventListener('change',update);
   if(selectors.length){
    const initial=JSON.parse(select.selectedOptions[0].dataset.options||'[]');
    selectors.forEach((input,index)=>{
     input.value=initial[index];
     input.addEventListener('change',()=>{
      const chosen=selectors.map(field=>field.value);
      const match=Array.from(select.options).find(option=>JSON.parse(option.dataset.options||'[]').every((value,i)=>value===chosen[i]));
      if(match){select.value=match.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
      else{select.selectedIndex=-1;button.disabled=true;button.textContent=button.dataset.unavailableLabel;if(buyNow)buyNow.hidden=true;select.dispatchEvent(new Event('change',{bubbles:true}));}
     });
    });
    form.querySelector('[data-reset-options]').hidden=false;
    form.querySelector('[data-reset-combined]').hidden=true;
    update();
   }
  });
  document.querySelectorAll('[data-reset-open]').forEach(button=>{
   if(button.dataset.bound)return;
   button.dataset.bound='true';
   button.addEventListener('click',()=>{
    const dialog=document.getElementById(button.dataset.resetOpen);
    if(!dialog||dialog.open)return;
    dialog.returnFocus=button;
    dialog.showModal();
   });
  });
  document.querySelectorAll('.reset-dialog').forEach(dialog=>{
   if(dialog.dataset.bound)return;
   dialog.dataset.bound='true';
   dialog.querySelector('[data-reset-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('close',()=>dialog.returnFocus?.focus());
   dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const b=dialog.getBoundingClientRect();
    if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();
   });
  });

 document.querySelectorAll('[data-kimo-product-gallery]').forEach(gallery=>{
  if(gallery.dataset.kimoGalleryBound)return;gallery.dataset.kimoGalleryBound='true';
  const main=gallery.querySelector('[data-kpg-main]'),modal=gallery.querySelector('[data-kpg-dialog]');
  gallery.addEventListener('click',event=>{
   const control=event.target.closest('[data-kpg-view],[data-kpg-zoom],[data-kpg-close]');
   if(!control||!gallery.contains(control))return;
   event.preventDefault();event.stopImmediatePropagation();
   if(control.hasAttribute('data-kpg-view')){
    if(matchMedia('(max-width:650px)').matches){const photo=modal.querySelector('img');photo.alt=control.querySelector('img').alt;photo.src=window.kimoImageURL(control.dataset.source,1600);if(!modal.open)modal.showModal();return;}
    const source=new URL(control.dataset.source,location.href);
    const width=main.clientWidth;source.searchParams.set('width',width<=440?'800':'1600');
    main.removeAttribute('srcset');main.removeAttribute('sizes');
    window.kimoLoadImage(main,source.href,control.querySelector('img').alt);
    gallery.querySelectorAll('[data-kpg-view]').forEach(view=>view.setAttribute('aria-pressed',String(view===control)));
   }else if(control.hasAttribute('data-kpg-zoom')){
    const selected=gallery.querySelector('[data-kpg-view][aria-pressed="true"]:not([hidden])'),chosen=selected?.dataset.source||main.src,label=selected?.querySelector('img')?.alt||main.alt;
    const source=new URL(chosen,location.href);source.searchParams.set('width','2000');
    const enlarged=modal.querySelector('img');enlarged.alt=label;enlarged.loading='eager';enlarged.src=window.kimoImageURL(chosen,main.clientWidth<=440?800:1600);window.kimoLoadImage(enlarged,source.href,label);
    if(!modal.open)modal.showModal();
   }else modal.close();
  },true);
 });

  document.querySelectorAll('[data-reset-buy-now]').forEach(buy=>{
   if(buy.dataset.bound)return;
   buy.dataset.bound='true';
   buy.addEventListener('click',async()=>{
    const form=buy.closest('form'),variant=form.querySelector('[data-reset-variant]'),message=form.querySelector('[data-kimo-buy-error]');
    if(!form.reportValidity()||variant.selectedOptions[0]?.dataset.available!=='true')return;
    buy.disabled=true;buy.setAttribute('aria-busy','true');buy.textContent=buy.dataset.loadingLabel;
    message.hidden=true;
    try{
     const result=await fetch((window.KIMO_ROOT||'/')+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
     const data=await result.json();
     if(!result.ok)throw new Error(data.description||buy.dataset.errorLabel);
     location.assign((window.KIMO_ROOT||'/')+'checkout');
    }catch(error){
     message.textContent=error.message||buy.dataset.errorLabel;message.hidden=false;
     buy.disabled=false;buy.removeAttribute('aria-busy');buy.textContent=buy.dataset.readyLabel;
    }
   });
  });
  document.querySelectorAll('[data-kimo-shop-pay]').forEach(link=>{
   if(link.dataset.bound)return;link.dataset.bound='true';
   link.addEventListener('click',async event=>{
    const form=link.closest('[data-cart-content]')?.querySelector('form');
    if(!form)return;event.preventDefault();
    if(!form.reportValidity()||link.getAttribute('aria-busy')==='true')return;
    const message=link.parentElement.querySelector('[data-kimo-shop-pay-error]'),label=link.textContent,originalStyle=link.getAttribute('style');
    link.setAttribute('aria-busy','true');link.style.setProperty('background-image','none','important');link.style.setProperty('color','#fff','important');link.textContent=link.dataset.loadingLabel;message.hidden=true;
    try{
     const response=await fetch((window.KIMO_ROOT||'/')+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
     const cart=await response.json();
     if(!response.ok)throw new Error(cart.description||link.dataset.errorLabel);
     if(!cart.items.length){location.assign((window.KIMO_ROOT||'/')+'cart');return;}
     const items=cart.items.map(item=>item.variant_id+':'+item.quantity).join(',');
     location.assign((window.KIMO_ROOT||'/')+'cart/'+items+'?payment=shop_pay');
    }catch(error){message.textContent=error.message||link.dataset.errorLabel;message.hidden=false;link.removeAttribute('aria-busy');if(originalStyle!==null)link.setAttribute('style',originalStyle);link.textContent=label;}
   });
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);document.addEventListener('kimo:cart-rendered',init);
})();

